module.exports = __webpack_public_path__ + "static/img/ma03.376413b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/ma03.jpg
// module id = P1W2
// module chunks = 0